// import $ from "jquery";
// import sqftShape from "./../core/shapes/sqftShape";
import sqftConfig from "./../store/sqftConfig";
import sqftStore from "./sqftStore";
import workspace from "../core/workspace";
import {
  BACKSPLASH_LABELS, CABINET_BOXES,
  COUNTERTOP_LABELS,
  isDisabledInPopupShouldBeHidden,
  MOVABLE_IMAGE_TYPES,
  RESOURCE_ATTACHED_TO_TYPE,
  SHAPE_PART_ID,
  SIDEBAR_NAVIGATION_BUTTONS,
  SQFT_CHILD_FEATURE_GROUP_PART_IDS,
  SQFT_SHAPES_THAT_ADD_OVERHANG
} from "../../../constants";
import sqftShape from "../core/shapes/sqftShape";
import MovableImage from "../core/shapes/movableImage";
import slabWorkspace from "../core/slab/slabWorkspace";
import {getPointField} from "../../../helpers/sqftHelper";
import ShapeRotatable from "../core/shapes/shapeParts/shapeRotatable";
import ChangeValuePopup from "../../popup/models/ChangeValuePopup";
import {
  addChangeValuePopup,
  changeValuePopup,
  deleteChangeValuePopup,
 //setSQFTActiveButton,
 //setSQFTMenuOpened
} from "../../../../../actions/sqftMenuFunctions";
import store from "../../../../../store";
import SqftStore from "./sqftStore";
import {updateSQFTCalculations} from "../../../../../actions/sqftFunctions";
import {isSFTCabinetsGroup} from "../../../helpers/sqftNavigationHelper";
import Rectangle from "../core/shapes/layouts/rectangle";
import {initTitle} from "../core/controls/labels/labelsHelper";
import {SLAB_IMAGE_TYPES} from "../../../../../reducers/sqftSlabReducer";
import sqftShapeIntersectionsManager from "./sqftShapeIntersectionsManager";
import {getCurrentLayout} from "../../../../appLayout";
import {SHAPE_PART_IDS_VISIBLE_ONLY_IN_THE_SLAB_MODE} from "../../../constantsFeature";
import {
  areCollinearAndOverlap,
  convexHull, removeConsecutiveDuplicates,
  roundShapePoints,
  unifyShapePoints
} from "../../../helpers/coordinatesHelper";
import {MAXIMUM_DEFAULT_BOTTOM_CABINET_HEIGHT} from "../../../helpers/sqftCabinetsDataMapper";

const sqftShapeManager = {
  shapes: [],
  objIds: 0,
  addShape: function(segments, shapeType, historyPosition, partId, fromLayout = null, shapeParams = {}) {
    const shapeId = workspace.addShape(segments, shapeType, historyPosition, partId, fromLayout, shapeParams);

    const state = store.getState();
    const updateCalculations = state.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));

    return shapeId
  },
  addPlaceholderShape: function(width, height) {
    const state = store.getState();
    const shouldUseSlabPricing = state.sqftSlabState.isSlabPricingEnabled;
    const shapeSegments = new Rectangle(width, height);
    const shapeId = sqftShapeManager.addShape(shapeSegments, 'square', null, SHAPE_PART_ID.slabPlaceHolder);
    const shape = sqftShapeManager.getShapeById(shapeId);
    sqftShapeIntersectionsManager.updateShapesIntersections();
    sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
    sqftShapeIntersectionsManager.updateShapesFeaturePlacedOnSlabImages();
    shape.deregisterLineEvents();
    shape.setSlabPricing(shouldUseSlabPricing);
    initTitle('PLACEHOLDER', SLAB_IMAGE_TYPES.placeholder, shape);
  },
  getShapeById: function(shapeId) {
    return workspace.getShapeById(shapeId);
  },
  getShapeByIds: function(ids) {
    return workspace.getShapes().filter(shape => ids.includes(shape.id));
  },
  hasSameFeatureId(shapes) {
    if (shapes.length === 0) return true;

    const firstFeatureId = shapes[0].featureId;
    for (let obj of shapes) {
      if (obj.featureId !== firstFeatureId) {
        return false;
      }
    }

    return true;
  },
  hasSameSharedFeatureName(shapes) {
    if (shapes.length === 0) return true;

    const firstFeatureId = shapes[0].featureId;
    const layout = getCurrentLayout();
    const currentShapeFeature = layout.getFeatureById(firstFeatureId, true);
    if (currentShapeFeature) {
      const currentShapeFeatureSharedName = currentShapeFeature.dbFeature.sharedFeatureName;
      for (let testShape of shapes) {
        const testShapeFeature = layout.getFeatureById(testShape.featureId, true);
        if (testShapeFeature && testShapeFeature.dbFeature.sharedFeatureName !== currentShapeFeatureSharedName) {
          return false;
        }
      }
    }

    return true;
  },
  removeShapeById: function(shapeId) {
    return workspace.removeShapeById(shapeId);
  },
  setShapeFeature: function (shapeId, visualizerFeature) {
    if (visualizerFeature && visualizerFeature.dbFeature) {
      let shape = workspace.getShapeById(shapeId);

      if (shape instanceof sqftShape || shape instanceof MovableImage) {
        shape.setFeatureId(visualizerFeature.dbFeature.id);
      } else if (shape && shape.type === RESOURCE_ATTACHED_TO_TYPE.backsplash) {
        const sqftShape = workspace.getShapeById(shape.attachedToParentId);
        const line = sqftShape.getLineById(shape.attachedToId);
        if (line) {
          line.setBacksplashFeatureId(visualizerFeature.dbFeature.id);
        }
      }
    }
  },
  setShapeFeatureId: function (shapeId, featureId) {
    let shape = workspace.getShapeById(shapeId);

    if (shape instanceof sqftShape || shape instanceof MovableImage) {
      shape.setFeatureId(featureId);
    }
  },
  setShapeRelatedParentFeatureId: function (shapeId, featureId, partId) {
    let shape = workspace.getShapeById(shapeId);

    if (shape instanceof sqftShape || shape instanceof MovableImage) {
      shape.relatedParentFeatureId = featureId;
      shape.parentPartId = partId;
    }
  },
  getCounterTopShapes() {
    const shapes = workspace.getShapes();

    return shapes.filter(function(shape) {
      const counterTopLabel = Object.keys(COUNTERTOP_LABELS).find(cLabel => cLabel === shape.type);
      if (counterTopLabel) {
        return true
      }
      return !shape.type
        && !SHAPE_PART_IDS_VISIBLE_ONLY_IN_THE_SLAB_MODE.includes(shape.partId)
    });
  },
  getBacksplashLabeledShapes() {
    const shapes = workspace.getShapesWithoutAttachedResources();

    return shapes.filter(shp => Object.keys(BACKSPLASH_LABELS).includes(shp.partId));
  },
  getCabinetShapes(partIds = CABINET_BOXES) {
    const shapes = workspace.getShapes();

    return shapes.filter(shp => Object.values(partIds).includes(shp.partId));
  },
  hideSeamShapes: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (
        shape.isWithShapePieces !== undefined
        && shape.isWithShapePieces()
        && (isDisabledInPopupShouldBeHidden() ? !shape.isDisabledInPopup : true)
      ) {
        shape.hideShapePieces()
      }
    })
  },
  restoreSeamShapes: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape.isWithShapePieces !== undefined
        && !shape.isWithShapePieces()
        && shape.isHidden
        && (isDisabledInPopupShouldBeHidden() ? !shape.isDisabledInPopup : true)
      ) {
        shape.reInitEvents()
      }
    })
  },
  hideSlabShapes: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape.partId === SHAPE_PART_ID.slabPlaceHolder) {
        shape.deregisterEvents();
      }
    })
  },
  restoreSlabShapes: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape.partId === SHAPE_PART_ID.slabPlaceHolder) {
        shape.reInitEvents();
        shape.deregisterLineEvents();
        shape.reInitLineTitleEvents();
      }
    })
  },
  hideMiteredSections: function() {
    const lines = workspace.getLines();
    for (const line of lines) {
      if (line.isWithMitered()) {
        line.miteredOverlay.deregisterEvents();
      }
    }
  },
  restoreMiteredSections: function() {
    const lines = workspace.getLines();
    for (const line of lines) {
      if (line.isWithMitered()) {
        line.miteredOverlay.reInitEvents();
      }
    }
  },
  resetShapeChangesInTheSlabMode: function (shape) {
    shape.updateSlabPoints();
    shape.removeShapePieces();
    shape.setShapePieces([]);
    shape.shapeSlab.setRotationDegreesSlab(0);
    slabWorkspace.slabAdditionalShapes.removeAllActiveBacksplashesAttachedToShape(shape);
  },
  checkForUpdateSlabPoints: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape instanceof sqftShape
        && ![SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(shape.partId)
      ) {
        if (shape.isPointsChanged) {
          shape.isPointsChanged = false;
          sqftShapeManager.resetShapeChangesInTheSlabMode(shape);
        }
      }
    })
  },
  checkForUpdateSlabPosition: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape instanceof sqftShape
        && ![SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(shape.partId)
      ) {
        if (shape.isPositionChanged) {
          shape.updateSlabPosition();
          shape.isPositionChanged = false;
          slabWorkspace.slabAdditionalShapes.removeAllActiveBacksplashesAttachedToShape(shape);
        }
      }
    })
  },
  hideCorePieceShapes: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape.isWithShapePieces !== undefined
        && shape.isWithShapePieces()
        && !shape.isHidden
        && ![SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(shape.partId)
        && (isDisabledInPopupShouldBeHidden() ? !shape.isDisabledInPopup : true)
      ) {
        shape.deregisterEvents()
      }
    })
  },
  restoreCorePieceShapes: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape.isWithShapePieces !== undefined
        && shape.isWithShapePieces()
        && shape.isHidden
        && ![SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(shape.partId)
        && (isDisabledInPopupShouldBeHidden() ? !shape.isDisabledInPopup : true)
    ) {
        shape.reInitEvents()
      }
    })
  },
  hideShapeParts: function(shouldSkipSlabPlaceHolders = true) {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape instanceof sqftShape
        && (isDisabledInPopupShouldBeHidden() ? !shape.isDisabledInPopup : true)
        && (shouldSkipSlabPlaceHolders && shape.partId !== SHAPE_PART_ID.slabPlaceHolder)
      ) {
        shape.deregisterPartEvents()
      }
    })
  },
  restoreShapeParts: function() {
    let shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape instanceof sqftShape
        && ![SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(shape.partId)
        && (isDisabledInPopupShouldBeHidden() ? !shape.isDisabledInPopup : true)
      ) {
        shape.reInitPartEvents()
      }
    })
  },
  // reInitMeasurementsInTheSlabMode: function() {
  //   const state = store.getState();
  //   const isMeasurementVisibleInSlabMode = state.sqftSlabState.isMeasurementVisibleInSlabMode;
  //   if (isMeasurementVisibleInSlabMode) {
  //     initAllLineLength()
  //   }
  // },
  undoSeam: function() {
    let seamHistory = sqftStore.getSeamHistory();
    if (seamHistory.length <= 0) {
      return
    }
    let latestShape = seamHistory.pop();
    for (let i = latestShape.shapePieces.length - 1; i >= 0; i--) {
      let shp = workspace.getShapeById(latestShape.shapePieces[i]);
      workspace.removeShape(shp);
    }
    latestShape.setShapePieces([]);
    latestShape.seamCutPointsAndLines = [];
    latestShape.reInitEvents();
    sqftShapeManager.hideShapeParts();
    sqftShapeManager.hideCorePieceShapes();
  },
  resetAllSeams: function() {
    this.restoreCorePieceShapes();
    this.hideShapeParts();
    let shapes = workspace.getShapes();
    for (let i = shapes.length - 1; i >= 0; i--) {
      if (shapes[i] instanceof sqftShape) {
        if (shapes[i].partId === SHAPE_PART_ID.seamPiece) {
          workspace.removeShape(shapes[i]);
        } else if (shapes[i].isWithShapePieces()) {
          shapes[i].seamCutPointsAndLines = [];
          shapes[i].setShapePieces([])
        }
      }
    }
    sqftStore.setSeamHistory([])
  },
  getVisibleCenter: function () {
    // console.log('sqftStore.ctxCenter', sqftStore.ctxCenter);
    // console.log('sqftStore.canvas', sqftStore.canvas);
    // console.log('sqftStore.scale', sqftConfig.scale);
    return {
      x: (sqftStore.ctxCenter.x + (sqftStore.canvas.width / 2)) / sqftConfig.scale,
      y: (sqftStore.ctxCenter.y + (sqftStore.canvas.height / 2)) / sqftConfig.scale
    }
  },
  getMinMax: (segments) => {
    let minX = null, maxX = 0;
    let minY = null, maxY = 0;
    for (let i = 0; i < segments.length; i++) {
      let s = segments[i];
      if (minX === null || s.from.x < minX)
        minX = s.from.x;
      if (s.from.x > maxX)
        maxX = s.from.x;
      if (minY === null || s.from.y < minY)
        minY = s.from.y;
      if (s.from.y > maxY)
        maxY = s.from.y
    }
    return {
      width: maxX - minX,
      height: maxY - minY,
      x: {
        min: minX,
        max: maxX
      },
      y: {
        min: minY,
        max: maxY
      }
    };
  },
  getMinMaxWorkspacePoints: (workspace, isIncludeBumpout = true) => {
    let from;
    let to;
    let minX = null;
    let maxX = null;
    let minY = null;
    let maxY = null;
    let offset = workspace.getOffset();
    let shapes = workspace.getShapes();
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      if (shape.getLines) {
        let lines = shape.getLines();
        for (let n = 0; n < lines.length; n++) {
          from = lines[n].from.getPointField();
          to = lines[n].to.getPointField();

          if (minX === null) {
            minX = from.x < to.x ? from.x : to.x;
            maxX = from.x > to.x ? from.x : to.x;
            minY = from.y < to.y ? from.y : to.y;
            maxY = from.y > to.y ? from.y : to.y;
          }

          if (isIncludeBumpout && lines[n].isWithBumpout && lines[n].isWithBumpout()) {
            [minX, maxX, minY, maxY] = sqftShapeManager.getMinMaxBumpoutPoints(lines[n], minX, maxX, minY, maxY);
          }

          minX = from.x < minX ? from.x : minX;
          maxX = from.x > maxX ? from.x : maxX;
          minX = to.x < minX ? to.x : minX;
          maxX = to.x > maxX ? to.x : maxX;

          minY = from.y < minY ? from.y : minY;
          maxY = from.y > maxY ? from.y : maxY;
          minY = to.y < minY ? to.y : minY;
          maxY = to.y > maxY ? to.y : maxY;
        }
      }
    }

    return {
      minX : minX - offset.x,
      maxX : maxX - offset.x,
      minY : minY - offset.y,
      maxY : maxY - offset.y
    }
  },
  disableRotatableStateForAllShapes: () => {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (shape instanceof sqftShape && shape.shapeRotatable) {
        sqftShapeManager.disableRotatableState(shape);
      }
    }
  },
  canShapeBeRotated: (shape) => {
    const isShapeCanBeRotated = shape instanceof sqftShape
      && shape.shapePieces.length === 0
      && !shape.isDisabledInPopup
      && !(shape.isWithBumpout() || shape.isWithMitered())
    ;
    const isMovableImageCanBeRotated = shape instanceof MovableImage && shape.type !== MOVABLE_IMAGE_TYPES.slabImage;
    return isShapeCanBeRotated || isMovableImageCanBeRotated
  },
  closeRotatablePopups: () => {
    const shapes = workspace.getShapes();
    shapes.forEach(shape => {
      if (shape.getIsRotatable && shape.getIsRotatable()) {
        sqftShapeManager.disableRotatableState(shape);
      }
    })
  },
  disableRotatableState: (shape) => {
    shape.setIsRotatable(false);
    shape.shapeRotatable.reInitShapePoints();
    shape.shapeRotatable.destroy();
    shape.shapeRotatable = null;
    store.dispatch(deleteChangeValuePopup('shape' + shape.id));
  },
  setShapeAsRotatable: (shape) => {
    const isSlabMode = SqftStore.isSlabMode();
    // todo fix rotation of slab images in slab mode
    if (shape instanceof MovableImage && shape.type === MOVABLE_IMAGE_TYPES.slabImage && isSlabMode) {
      return
    }
    shape.shapeRotatable = new ShapeRotatable(shape);
    shape.setIsRotatable(true);
    const shapeOffset = shape.getOffset();
    const isCabinet = isSFTCabinetsGroup();
    let changeValuePopupPosition;
    if (isCabinet) {
      const shapeDepth = shape.getDepth();
      const shapeWidth = shape.getWidth();
      changeValuePopupPosition = {left: shapeOffset.x, top: shapeOffset.y - (shapeDepth + shapeWidth) * sqftConfig.scale / 2}
    } else {
      changeValuePopupPosition = {left: shapeOffset.x, top: shapeOffset.y}
    }

    const changeRotatedDegreeValuePopup = new ChangeValuePopup(
      'shape' + shape.id,
      0,
      360,
      () => {
        sqftConfig.workspace.menuItemActive = SIDEBAR_NAVIGATION_BUTTONS.move
        sqftShapeManager.disableRotatableState(shape);
        //store.dispatch(setSQFTMenuOpened(''));
        //store.dispatch(setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.rotate));
      },
      () => {
        const state = store.getState();
        const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === 'shape' + shape.id);
        shape.rotate(1, shape.Direction.LEFT, isSlabMode);
        const newValuePopup = {...valuePopup, value: isSlabMode ? shape.rotatedDegreesSlab : shape.rotatedDegrees};
        store.dispatch(changeValuePopup(newValuePopup));
      },
      () => {
        const state = store.getState();
        const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === 'shape' + shape.id);
        const value = (isSlabMode ? shape.rotatedDegreesSlab : shape.rotatedDegrees) - 1 < 0 ? 359 : -1 ;
        shape.rotate(value, shape.Direction.LEFT, isSlabMode);
        store.dispatch(changeValuePopup({...valuePopup, value: isSlabMode ? shape.rotatedDegreesSlab : shape.rotatedDegrees}));
      },
      (e) => {
        const state = store.getState();
        const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === 'shape' + shape.id);
        const value = parseInt(e.target.value);
        if (Number.isInteger(value) && 359 > value > 0) {
          shape.rotate(value - (isSlabMode ? shape.rotatedDegreesSlab : shape.rotatedDegrees), shape.Direction.LEFT, isSlabMode);
          isSlabMode ? shape.rotatedDegreesSlab = value : shape.rotatedDegrees = value;
          store.dispatch(changeValuePopup({...valuePopup, value: value}));
        }
      },
      isSlabMode ? shape.rotatedDegreesSlab : shape.rotatedDegrees,
      changeValuePopupPosition
    );
    store.dispatch(addChangeValuePopup(changeRotatedDegreeValuePopup));
  },

  rotateShapeTo90Deg: (shape) => {
    // Check if the slab mode is active
    const isSlabMode = SqftStore.isSlabMode();
    const state = store.getState();

    // Find the corresponding popup for changing shape values
    const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === 'shape' + shape.id);

    // Determine the current rotation angle
    const currentRotation = isSlabMode ? shape.rotatedDegreesSlab : shape.rotatedDegrees;


    if ([0, 90, 180, 270, 360].includes(currentRotation)) {
      // Calculate the new rotation angle, adding 90 degrees and ensuring it wraps around after 360
      const newRotation = (currentRotation + 90) % 360;

      // Rotate the shape by the difference between the new and current rotation angles
      shape.rotate(newRotation - currentRotation, shape.Direction.LEFT, isSlabMode);

      // Update the shape's rotation angle based on whether slab mode is active
      if (isSlabMode) {
        shape.rotatedDegreesSlab = newRotation;
      } else {
        shape.rotatedDegrees = newRotation;
      }

      store.dispatch(changeValuePopup({...valuePopup, value: newRotation}));
    }
  },

  getShapeCornerPoints: () => {
    //todo
  },
  getMinMaxBumpoutPoints: (line, minX, maxX, minY, maxY, isPointOnField) => {
    let bumpoutPoints = line.bumpoutOverlay.getBumpoutPoints();
    let pointField;
    if (isPointOnField) {
      pointField = getPointField(bumpoutPoints.dragPoint.x, bumpoutPoints.dragPoint.y, line.getParent())
    } else {
      pointField = bumpoutPoints.dragPoint
    }
    minX = pointField.x < minX ? pointField.x : minX;
    maxX = pointField.x > maxX ? pointField.x : maxX;
    minY = pointField.y < minY ? pointField.y : minY;
    maxY = pointField.y > maxY ? pointField.y : maxY;

    return [minX, maxX, minY, maxY]
  },

  getMinMaxShapesPointsOnWorkspace: (shapes, shouldGetRegularPosition = false) => {
    if (shapes.length > 0) {
      let shapesPoints = [];
      shapes.forEach(shp => {
        if (shp.getPointsPosOnWorkspace) {
          shapesPoints.push(...shp.getPointsPosOnWorkspace(shouldGetRegularPosition));
          if (shp.getBumpoutPointsPosOnWorkspace) {
            shapesPoints.push(...shp.getBumpoutPointsPosOnWorkspace());
          }
        }
      });
      shapesPoints.push(...workspace.textBoxManager.getTextBoxPointsOnWorkspace());
      let pointsMinMax = sqftShapeManager.getMinMaxPoints(shapesPoints, false);

      //console.log("shapesMinMax", pointsMinMax);

      return [
        {x: pointsMinMax.minX, y: pointsMinMax.minY},
        {x: pointsMinMax.maxX, y: pointsMinMax.minY},
        {x: pointsMinMax.maxX, y: pointsMinMax.maxY},
        {x: pointsMinMax.minX, y: pointsMinMax.maxY}
      ];
    }
    return []
  },
  getShapesConvexHullPointsOnWorkspace: (shapes) => {
    if (shapes.length > 0) {
      let shapesPoints = [];
      shapes.forEach(shp => {
        shapesPoints.push(...shp.getPointsPosOnWorkspace());
      });
      return convexHull(shapesPoints);
    }
    return []
  },
  getShapesConvexHullPointsPointField: (shapes) => {
    if (shapes.length > 0) {
      let shapesPoints = [];
      shapes.forEach(shp => {
        shapesPoints.push(...shp.getPointsPointField());
      });
      return convexHull(shapesPoints);
    }
    return []
  },
  getShapesContourPointsOnWorkspace: (shapes, shouldRemoveRepeatingPoints = true) => {
    if (shapes.length > 0) {
      const shapesPointsOnWorkspace = shapes.map(shp => shp.getPointsPosOnWorkspace());
      let unifiedContours = unifyShapePoints(shapesPointsOnWorkspace);

      if (shouldRemoveRepeatingPoints) {
        unifiedContours = unifiedContours.map(contour => removeConsecutiveDuplicates(contour));
      }

      return unifiedContours;
    }
    return [];
  },
  getShapesOverhangOnWorkspace: (contourPoints, snappedShapes, minOverlap = 2) => {
    const shapes = workspace.getShapesWithoutAttachedResources();
    const overhangShapes = shapes.filter(shp => {
        const isHeightForTheTallCabinet = shp.getInitialHeight() > MAXIMUM_DEFAULT_BOTTOM_CABINET_HEIGHT;
        const canShapeCreateOverhang = SQFT_SHAPES_THAT_ADD_OVERHANG.includes(shp.subType)
          || SQFT_SHAPES_THAT_ADD_OVERHANG.includes(shp.partId)
          || isHeightForTheTallCabinet;
        const isShapeInsideSnappedShapes = snappedShapes.includes(shp);
        if (canShapeCreateOverhang && !isShapeInsideSnappedShapes) {
          void 0;
        }
        return canShapeCreateOverhang && !isShapeInsideSnappedShapes
      }
    );
    let results = new Array(contourPoints.length ? contourPoints.length - 1 : 0).fill(true);

    if (overhangShapes.length > 0) {
      for (const overhangShape of overhangShapes) {
        const pointsPosOnWorkspace = overhangShape.getPointsPosOnWorkspace();
        const roundedPoints = roundShapePoints(pointsPosOnWorkspace);
        roundedPoints.push(roundedPoints[0]); //close polygon

        for (let i = 0; i < contourPoints.length - 1; i++) {
          const cp1 = contourPoints[i];
          const cp2 = contourPoints[i + 1];
          for (let j = 0; j < roundedPoints.length - 1; j++) {
            const rp1 = roundedPoints[j];
            const rp2 = roundedPoints[j + 1];
            if (areCollinearAndOverlap(cp1, cp2, rp1, rp2, minOverlap)) {
              results[i] = false;
              break;
            }
          }
        }
      }
    }
    //debugger // eslint-disable-line no-debugger
    return results
  },
  getShapesContourPointsPointField: (shapes) => {
    if (shapes.length > 0) {
      const shapesPointField = shapes.map(shp => {
        return shp.getPointsPointField();
      });
      return unifyShapePoints(shapesPointField);
    }
    return []
  },
  getMinMaxShapePoints: (shape, isIncludeBumpout = true, isPointOnField = true) => {
    let from;
    let to;
    let minX = null;
    let maxX = null;
    let minY = null;
    let maxY = null;
    let lines = shape.getLines();
    //let offset = workspace.getOffset();

    for (let n = 0; n < lines.length; n++) {
      if (isPointOnField) {
        from = getPointField(lines[n].from.x, lines[n].from.y, shape);
        to = getPointField(lines[n].to.x, lines[n].to.y, shape);
      } else {
        from = lines[n].from;
        to = lines[n].to;
      }

      if (minX === null) {
        minX = from.x < to.x ? from.x : to.x;
        maxX = from.x > to.x ? from.x : to.x;
        minY = from.y < to.y ? from.y : to.y;
        maxY = from.y > to.y ? from.y : to.y;
      }

      if (isIncludeBumpout && lines[n].isWithBumpout()) {
        [minX, maxX, minY, maxY] = sqftShapeManager.getMinMaxBumpoutPoints(lines[n], minX, maxX, minY, maxY , isPointOnField);
      }

      minX = from.x < minX ? from.x : minX;
      maxX = from.x > maxX ? from.x : maxX;
      minX = to.x < minX ? to.x : minX;
      maxX = to.x > maxX ? to.x : maxX;

      minY = from.y < minY ? from.y : minY;
      maxY = from.y > maxY ? from.y : maxY;
      minY = to.y < minY ? to.y : minY;
      maxY = to.y > maxY ? to.y : maxY;
    }

    return {
      minX : minX,
      maxX : maxX,
      minY : minY,
      maxY : maxY
    }
  },
  getMinMaxPoints: (points, isPointOnField = true) => {
    let point;
    let minX = null;
    let maxX = null;
    let minY = null;
    let maxY = null;

    for (let n = 0; n < points.length; n++) {
      if (isPointOnField) {
        point = getPointField(points[n].x, points[n].y, points[n].getGrandParent ? points[n].getGrandParent(): workspace);
      } else {
        point = points[n];
      }

      if (minX === null) {
        minX = point.x;
        maxX = point.x;
        minY = point.y;
        maxY = point.y;
      }

      minX = point.x < minX ? point.x : minX;
      maxX = point.x > maxX ? point.x : maxX;
      minY = point.y < minY ? point.y : minY;
      maxY = point.y > maxY ? point.y : maxY;
    }

    return {
      minX : minX,
      maxX : maxX,
      minY : minY,
      maxY : maxY
    }
  },
  setIsDisabledShapeInPopup: (id, isDisabledInPopup) => {
    let shape = sqftShapeManager.getShapeById(id);
    if (shape) {
      shape.isDisabledInPopup = isDisabledInPopup;
      if (isDisabledInPopupShouldBeHidden()) {
        if (isDisabledInPopup && shape.deregisterEvents) {
          shape.deregisterEvents()
          shape.shapeSlab.resetShapeSeams();
        } else if (shape.reInitEvents) {
          shape.reInitEvents();
        }
      }
    }
  },
  getSnappedShapes: (snappedShapeGroup) => {
      const shapes = workspace.getShapes();
      return shapes.filter(shp => {
        return !!(shp.shapeAbsolute && (shp.shapeAbsolute.getSnappedShapeGroup() === snappedShapeGroup))
      })
  },

  changeShapesFeatureIDIfColorWasChanged: (feature) => {
    if (feature && feature.partId) {
      const shapes = workspace.getShapes();
      const partId = Object.keys(SQFT_CHILD_FEATURE_GROUP_PART_IDS).includes(feature.partId)
        ? SQFT_CHILD_FEATURE_GROUP_PART_IDS[feature.partId]
        : feature.partId;

      //also include spacers
      const filteredShapes = shapes.filter(shape => shape.partId === partId || shape.parentPartId === partId );
      filteredShapes.forEach((shape) => {
        if (shape instanceof sqftShape) {
          shape.changeFeatureIdIfColorWasChanged(feature);
        }
      })
    }
  },
  updateShapeColorSet: (shapeId) => {
    const shape = workspace.getShapeById(shapeId);
    if (shape instanceof sqftShape) {
      shape.updateColorSet();
    }
  },
  updateMinMaxMiteredPoints: (shape) => {
    const lines = shape.getLines();
    for (const line of lines) {
      if (line.isWithMitered()) {
        line.miteredOverlay.updateMinMaxPoints();
      }
    }
  }
};

export default sqftShapeManager
